import React from "react";
import ReactLoading from "react-loading";

const Loading = ({ className, height = "100%", width = "100%", size = 50 }) => {
	return (
		<div
			className={className}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: height,
				width: width,
			}}
		>
			<ReactLoading
				height={size}
				width={size}
				className="spinner"
				type="spin"
				color="#d7d7d7"
			/>
		</div>
	);
};

export default Loading;
